import React from 'react';
import { Avatar } from '@mui/material';

const BusinessLogo = ({ 
  photoUrl, 
  businessName, 
  size = 48, 
  variant = "rounded",
  sx = {}
}) => {
  if (photoUrl) {
    return (
      <Avatar
        variant={variant}
        src={photoUrl}
        alt={`${businessName} logo`}
        sx={{ 
          width: size, 
          height: size,
          ...sx
        }}
      />
    );
  }
  
  return (
    <Avatar
      variant={variant}
      sx={{ 
        width: size, 
        height: size,
        bgcolor: 'primary.light',
        color: 'primary.contrastText',
        fontSize: size > 48 ? 20 : 16,
        ...sx
      }}
    >
      {businessName[0].toUpperCase()}
    </Avatar>
  );
};

export default BusinessLogo;